export default __webpack_public_path__ + "static/media/sinkPointers.6e32119f.png";